@if (!dashboardView || (runsInApp() && !fcmToken())) {
  <!--@if (dashboardView) {
    <p-divider align="left" class="pt-2">
      <div class="inline-flex gap-2 align-items-center">
        <i class="pi pi-bell"></i>
        <b>{{'PUSH_NOTIFICATIONS' | translate}}</b>
      </div>
    </p-divider>
  }-->
  <div [class.pb-3]="!dashboardView" [class.pt-3]="dashboardView" [class.pb-1]="dashboardView">
    @if (runsInApp()) {
      <div class="flex align-items-center gap-2">
        <span>{{ (dashboardView ? 'PUSH_NOTIFICATIONS' : 'STATUS') | translate }}:</span>
        @if (fcmToken()) {
          <span class="text-green">{{ 'ACTIVATED' | translate }}</span>
          @if (isTestServer) {
            <i class="pi pi-info-circle cursor-pointer" (click)="showTokenDetails()"></i>
            <p-button [label]="'TEST' | translate" (onClick)="testPushNotification()" styleClass="p-button-text"/>
          }
        } @else {
          <p-button [label]="'ENABLE_PUSH_NOTIFICATIONS' | translate" (onClick)="requestToken()"
                    icon="pi pi-bell" styleClass="p-button-text"/>
        }
      </div>
    } @else {
      <div class="flex align-items-center">
        <!--<app-info-text [text]="('PUSH_NOTIFICATIONS' | translate) + ' - ' + ('COMING_SOON' | translate)" color="text-gray-400"/>-->
      <app-info-text text="PLAYER_PROFILE_RUN_IN_APP_TO_ACTIVATE_PUSH_NOTIFICATIONS" color="text-gray-400"/>
        @if (isLocal) {
          <p-button [label]="'TEST' | translate" (onClick)="testPushNotification()" styleClass="p-button-text"/>
        }
      </div>
    }
  </div>
}
